export class Navigation {
	/**
	 * Init the class
	 *
	 * @param {HTMLElement} rootEl The root element of the block
	 */
	constructor(rootEl) {
		// Define classes, selectors, and magic
		this.controlClass = 'menu-open';
		this.subMenuOpenClass = 'sub-menu-open';
		this.navigation = 'main-navigation';
		this.header = document.getElementsByTagName('header')[0];

		// Toggle menu
		rootEl.addEventListener('click', this.menuToggleClicked.bind(this));

		// Add event listener on scroll
		document.addEventListener('scroll', this.resizeNavigation.bind(this)); // eslint-disable-line

		// Add event listener on load
		window.addEventListener('load', this.resizeNavigation()); // eslint-disable-line

		// Add event listener to check scroll direction
		document.addEventListener('scroll', this.toggleStickyNav.bind(this)); // eslint-disable-line

		// Add event listener to toggle mobile menu
		const toggleBtns = this.header.querySelectorAll('.toggle-children');
		const self = this;
		toggleBtns.forEach((btn) => {
			btn.addEventListener('click', function () {
				self.toggleSubMenu(this);
			});
		});
	}

	/*
	 * Toggles class in body tag when menu is open / closed
	 *
	 * @return    {void}
	 */
	menuToggleClicked() {
		const alreadyOpen = document.body.classList.contains(this.controlClass);

		// Add the body class
		if (!alreadyOpen) {
			document.body.classList.add(this.controlClass);
		} else {
			document.body.classList.remove(this.controlClass);
		}
	}

	/*
	 * Adds / removes active class on navigation on scroll
	 *
	 * @return    {void}
	 */
	resizeNavigation() {
		const offset = window.pageYOffset;
		const navigation = document.getElementById(this.navigation);
		if (offset > 106) {
			navigation.classList.add('site-header--scroll-active');
		} else {
			navigation.classList.remove('site-header--scroll-active');
		}
	}

	/*
	 * Adds / removes top navigation from viewport on scroll up / down
	 *
	 * @return    {void}
	 */
	toggleStickyNav() {
		const offset = window.pageYOffset || document.documentElement.scrollTop;
		if (offset > this.lastScrollTop) {
			this.header.classList.remove('header--scroll-active');
			if (offset > 150) {
				this.header.classList.remove('header--scroll-active');
			} else {
				this.header.classList.remove('header--scroll-active');
			}
		} else {
			this.header.classList.add('header--scroll-active');
		}
		this.lastScrollTop = offset <= 0 ? 0 : offset;
	}

	/*
	 * Toggles sub menu on click on mobile
	 * @param {HTMLElement} btn The button element
	 * @return    {void}
	 */
	toggleSubMenu(btn) {
		const parentElement = btn.parentElement;
		const alreadyOpen = parentElement.classList.contains(
			this.subMenuOpenClass
		);

		// Add the body class
		if (!alreadyOpen) {
			parentElement.classList.add(this.subMenuOpenClass);
		} else {
			parentElement.classList.remove(this.subMenuOpenClass);
		}
	}
}
